import React from 'react';
import './Header.css';

export default function Header() {
  return (
    <header className="tp-header">
      <div className="container tp-header__inner">
        <a href="/" className="tp-header__brand">
          <img src="/assets/faye-logo-purple.png" alt="Faye" className="tp-header__logo" />
          <span className="tp-header__plus">Travel+</span>
        </a>
      </div>
    </header>
  );
}
